import { Close, Done } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export function ReadOnlyIsPrivateLedger({
  isPrivate = false,
}: {
  isPrivate: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {isPrivate ? (
        <>
          <Done fontSize="large" color="success" />
          <Typography variant="body1">
            Private ledger on client dashboard
          </Typography>
        </>
      ) : (
        <>
          <Close fontSize="large" color="error" />
          <Typography variant="body1">
            Private ledger on client dashboard
          </Typography>
        </>
      )}
    </Box>
  );
}
